import { ICellRendererParams } from "ag-grid-community";
import { Stack, Typography } from "@mui/joy";
import ReactRouterLink from "@/components/ReactRouterLink/ReactRouterLink";
import { AgentObj } from "@/types/interfaces/agents";
import isTtandBranded from "@/utils/isTtandBranded";
import { getStatusColor } from "./utils";

// showBrand adds the agency the agent trades as on a second line (the grid's row height needs to allow for it). Left
// out for the TTAND brands most agents use, so the custom brands stand out
export const NameCellRenderer = ({ data, showBrand }: ICellRendererParams<AgentObj> & { showBrand?: boolean }) => (
  <Stack justifyContent="center" sx={{ minWidth: 0, height: "100%", lineHeight: 1.25 }}>
    <Typography
      component={ReactRouterLink}
      noWrap
      color={getStatusColor(data)}
      to={`/admin/agents/profile?email=${encodeURIComponent(data?.ttandEmail || "")}`}
      fontWeight={"lg"}
      sx={{ mr: 1, fontSize: "inherit" }}
    >
      {data?.name}
    </Typography>
    {showBrand && data?.brandedAs && !isTtandBranded(data.brandedAs) && (
      <Typography noWrap level="body-xs" textColor="text.tertiary" title={data.brandedAs}>
        {data.brandedAs}
      </Typography>
    )}
  </Stack>
);
